const Styles = {
    Global:{
        Button: "rounded-full bg-secondaryDark hover:bg-secondary px-16 py-4 my-8 text-white font-bold",
        InstagramLogoGradient: "bg-gradient-to-r from-InstagramLogoColorFrom via-InstagramLogoColorVia to-InstagramLogoColorTo",
    },
    NavBar:{
        Button: "text-2xl text-tertiary p-4 hover:bg-tertiary hover:text-black h-24 size-full",
        ButtonAlt: "text-2xl text-black text-left p-8 h-24 w-screen",
        DropDownMenu: {
            Septerator: "border border-gray-300", 
            MenuItem: "text-left px-4 py-2 bg-tertiary text-lg w-full hover:bg-tertiaryDark",
            MenuItemAlt: "text-left px-4 py-3 bg-Secondary text-lg w-full",
        }
    },
    Quote:{
        Input: "p-4 m-2 rounded-xl w-5/6 lg:w-1/2 border-2 ",
        Button: "rounded-full bg-primary/70 hover:bg-secondaryDark px-16 py-4 my-8 w-2/3 text-white text-center font-bold",
    }
};

export default Styles